export default __webpack_public_path__ + "static/media/Cal_B.a55cf674.jpg";